module.exports = __webpack_public_path__ + "img/paxDrive.4b8439f3.jpeg";